import React from "react";
import { TextArea } from "../../../../../ui/components/TextArea";
import { FieldFootnote } from "./FieldFootnote";
import { FieldRowProps } from "./fieldTypes";

/** A multi-line text field, for the longer descriptive answers. */
export const TextAreaFieldRow: React.FC<FieldRowProps> = ({
  config,
  value,
  locked,
  lockReason,
  errorMessage,
  onChange,
}) => (
  <div className="flex w-full flex-col gap-1">
    {/* TextArea's root takes no `disabled` — only the inner control does. */}
    <TextArea className="w-full" label={config.label} error={Boolean(errorMessage)}>
      <TextArea.Input
        className="min-h-24"
        value={value}
        rows={config.rows ?? 4}
        placeholder={config.placeholder}
        disabled={locked}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => onChange(event.target.value)}
      />
    </TextArea>

    <FieldFootnote
      hint={config.hint}
      example={config.example}
      lockReason={lockReason}
      errorMessage={errorMessage}
    />
  </div>
);
